<!--入口页-->
<template>
  <div id="app">
    <!-- <keep-alive> -->
    <router-view></router-view>
    <!-- </keep-alive> -->
  </div>
</template>
<script>
export default {
  name: 'App'
};
</script>

<style>
@import '//at.alicdn.com/t/font_1471022_ic3l9e7nlpd.css';
/* @import '../static/css/gh-fork-ribbon.css'; */
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*color: #2c3e50;*/
  color: #303133;
  margin: 0;
  padding: 0;
  font-size: 14px;
}


/** webkit 支持的滚动条 */
::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  /*background: transparent;*/
  border:2px solid #fff;
  opacity: 0.6;
  border-radius: 10px;
  transition: 1s;
  background-color: rgba(144,147,153,.3);
}
::-webkit-scrollbar-thumb:hover{
  background-color: rgba(144,147,153,.5);
}
</style>



// WEBPACK FOOTER //
// src/App.vue